import EventDispatcher from "../framework/EventDispatcher";
import ScriptInstanceService from "../services/ScriptInstanceService";
import PaymentService from '../services/PaymentService';
import LocalStorageService from '../services/LocalStorageService';

import {loadUserAccount} from "../actions/UserAccountActions";

import PaymentMethodDto from '../model/payment/PaymentMethodDto';

import { get } from 'lodash';

// Action Types
const CLEAR_STATUS = 'customercare/modules/payment/CLEAR_STATUS';
const OPEN_INGENICO = 'customercare/modules/payment/OPEN_INGENICO';
const VALIDATE_SEPA = 'customercare/modules/payment/VALIDATE_SEPA';
const TOGGLE_PM_CHOICE_WINDOW = "customercare/modules/payment/TOGGLE_PM_CHOICE_WINDOW";
const TOGGLE_NEW_SEPA_WINDOW = "customercare/modules/payment/TOGGLE_NEW_SEPA_WINDOW";
const TOGGLE_NEW_INGENICO_WINDOW = "customercare/modules/payment/TOGGLE_NEW_INGENICO_WINDOW";
const SAVE_PAYMENT = 'customercare/modules/payment/SAVE_PAYMENT';
const GET_HOSTED_CHECKOUT = 'customercare/modules/payment/GET_HOSTED_CHECKOUT';
const CONFIRM_HOSTED_CHECKOUT_STATUS = 'customercare/modules/payment/CONFIRM_HOSTED_CHECKOUT_STATUS';
const LOAD_PAYMENT_SESSION = 'customercare/modules/payment/LOAD_PAYMENT_SESSION';

// Reducer
export default function reducer(state = {}, action = {}) {
	switch (action.type) {
		case EventDispatcher.successAction(OPEN_INGENICO):
			const ingenico = action.data.result;
			const status = action.data.status;
			!!status && (state.status = status);
			return {
				...state,
				status,
				ingenico
			};
			break;
		case EventDispatcher.successAction(CLEAR_STATUS):
			return {};
			break;
		case EventDispatcher.successAction(VALIDATE_SEPA): {
			const {form, validPayment, status} = action.data;
			return {
				...state,
				SEPA: {
					form,
					validPayment,
					status
				}
			};
		}
			break;
		case EventDispatcher.errorAction(VALIDATE_SEPA): {
			const {error: {message = ""}} = action.data;
			return {
				...state,
				SEPA: {
					status: "FAIL",
					error: message
				},
				
			};
		}
			break;
		case EventDispatcher.successAction(TOGGLE_PM_CHOICE_WINDOW): {
			const {status} = action.data;
			return {
				...state,
				paymentMethodStatus:{
					openPMChoicesDialog: status
				}
			};
		}
			break;
		case EventDispatcher.successAction(TOGGLE_NEW_SEPA_WINDOW): {
			const {status} = action.data;
			return {
				...state,
				paymentMethodStatus: {
					openNewSepaWindow: status
				}
			};
		}
			break;
		case EventDispatcher.successAction(TOGGLE_NEW_INGENICO_WINDOW): {
			const {status} = action.data;
			return {
				...state,
				paymentMethodStatus:{
					openNewIngenicoWindow: status
				}
			};
		}
			break;
		case EventDispatcher.successAction(SAVE_PAYMENT): {
			return {
				paymentMethodStatus:{
					openPMChoicesDialog: false,
					openNewSepaWindow: false,
					openNewIngenicoWindow: false
				}
			};
		}
		case EventDispatcher.successAction(GET_HOSTED_CHECKOUT): {
			const {hostedCheckoutUrl, status, pageId} = action.data;
			return {
				hostedCheckoutUrl,
				pageId,
				status: {
					...state.status,
					...status
				}
			};
		}
		case EventDispatcher.successAction(CONFIRM_HOSTED_CHECKOUT_STATUS): {
			const {isHostedCheckout, status} = action.data;
			return {
				isHostedCheckout,
				status: {
					...state.status,
					...status
				}
			};
		}
		case EventDispatcher.errorAction(CONFIRM_HOSTED_CHECKOUT_STATUS): {
			const {error} = action.data;
			return {
				...state,
				status: {
					...state.status,
					hostedCheckoutConfirmed: true,
					paymentStatus : "ERROR"
				},
				error
			};
		}
		case EventDispatcher.successAction(LOAD_PAYMENT_SESSION): {
			const {payment} = action.data;
			return {
				...payment
			};
		}
			break;
		default:
			return state;
	}
}


// Actions
export function openIngenico(data) {
	return dispatch => {
		EventDispatcher.loading(dispatch, OPEN_INGENICO);
		ScriptInstanceService.executeScriptGET(data)
			.then(response => {
				const {result, status} = response;
				if (!status || status === "FAIL") {
					throw Result.status;
				} else {
					const {result} = response;
					EventDispatcher.success(dispatch, OPEN_INGENICO, {result, status});
				}
			})
			.catch(error => {
				EventDispatcher.error(dispatch, OPEN_INGENICO, error);
			});
	}
}

export function clearPaymentStatus() {
	return dispatch => {
		EventDispatcher.success(dispatch, CLEAR_STATUS);
	};
}

export function togglePMChoiceWindow(status){
	return dispatch => {
		EventDispatcher.success(dispatch, TOGGLE_PM_CHOICE_WINDOW, {status});
	};
}
export function toggleNewSepaWindow(status){
	return dispatch => {
		EventDispatcher.success(dispatch, TOGGLE_NEW_SEPA_WINDOW, {status});
	};
}
export function toggleNewIngenicoWindow(status){
	return dispatch => {
		EventDispatcher.success(dispatch, TOGGLE_NEW_INGENICO_WINDOW, {status});
	};
}

export function validateSepa(form) {
	return (dispatch, getStore) => {
		EventDispatcher.loading(dispatch, VALIDATE_SEPA);
		const store = getStore();
		const {messages:{messages= []}} = store;
		// const bic = form.bic;
		const iban = form.iban1 + form.iban2 + form.iban3 + form.iban4 + form.iban5 + form.iban6;
		// const acceptedIban = iban.startsWith("FR") || iban.startsWith("GP") || iban.startsWith("GF") 
		// || iban.startsWith("RE") || iban.startsWith("MQ") ||  iban.startsWith("PF") ||  iban.startsWith("NC")
		
		// if(!acceptedIban){
		// 	EventDispatcher.error(dispatch, VALIDATE_SEPA, {message: messages["payment.method.iban.error"]});
		// }else{
			// PaymentService.validate(iban, bic)
			PaymentService.validate(iban)
				.then(response => {
					const {status} = response;
					if (status === null || status === "FAIL") {
						EventDispatcher.error(dispatch, VALIDATE_SEPA, {message: messages["invalid.iban"]});
					} else {
						EventDispatcher.success(dispatch, VALIDATE_SEPA, {form, validPayment: {iban}, status});
					}
				})
				.catch(error => {
					EventDispatcher.error(dispatch, VALIDATE_SEPA, error);
				});
			// }
	};
}

export function savePaymentMethod() {
	return (dispatch, getState) => {
		EventDispatcher.loading(dispatch, SAVE_PAYMENT);
		const store = getState();
		const { account={}, payment={}, messages:{messages=[]}} = store;
		const { SEPA={}} = payment;
		const {validPayment, form} = SEPA || {};
		const paymentMethod = new PaymentMethodDto({
			...validPayment,
			customerAccount: get(account,'userAccount.billingAccount.customerAccount'),
		});
		PaymentService.addPayment(paymentMethod)
			.then(response => {
				const {status} = response;
				if (status === null || status === "FAIL") {
					EventDispatcher.error(dispatch, SAVE_PAYMENT, {message: messages["payment.method.save.error"]});
				} else {
					dispatch(loadUserAccount());
					EventDispatcher.success(dispatch, SAVE_PAYMENT);
				}
			})
			.catch(error => {
				EventDispatcher.error(dispatch, SAVE_PAYMENT, error);
			});
	};
}

export function getHostedCheckout() {
	return (dispatch, getStore) => {
		EventDispatcher.loading(dispatch, GET_HOSTED_CHECKOUT);
		const paymentSessionId = Date.now().toString(36)
		const storeState = getStore();
		const {account:{userAccount= {}}} = storeState;
		const customer = get(userAccount, 'billingAccount.customerAccount.customer', {});
		const {code:customerCode = ""}= customer;
		const {seller={}} = customer;
		// const {seller: parentSeller = {}} = seller;
		// const {seller: rootSeller = {}} = parentSeller;
		const {code: rootSellerCode = ""} = seller;

		// // get amount with tax from published version
		// const { versions = {}} = offerPricePlan || {};
		// const publishedVersion = versions.find(version => version.status === "PUBLISHED");
		// const { amountWithTax = 0} = publishedVersion || {};

		// // Convert amount to Cent
		// const paymentAmount = amountWithTax*100;

		PaymentService.getHostedCheckout(customerCode, rootSellerCode, 100, `${window.location.href.split('?')[0]}?sessionId=${paymentSessionId}`)
			.then(response => {
				const {result = {}} = response || {};
				const {hostedCheckoutUrl = {}, id = ""} = result;
				EventDispatcher.success(dispatch, GET_HOSTED_CHECKOUT, {hostedCheckoutUrl, pageId: id, status: {hostedCheckout: true}});
				// Save ingenico payment state
				const { payment={} } = getStore() || {};
				LocalStorageService.set(paymentSessionId, payment);
				// Redirect to ingenico interface
				window.location.replace(hostedCheckoutUrl);
			})
			.catch(error => {
				EventDispatcher.error(dispatch, GET_HOSTED_CHECKOUT, error);
			});
	};
}

export function confirmHostedCheckout() {
	return (dispatch, getStore) => {
		EventDispatcher.loading(dispatch, CONFIRM_HOSTED_CHECKOUT_STATUS);
		const storeState = getStore();
		const {account:{userAccount= {}}, payment: {pageId = ""}, messages:{messages=[]}} = storeState;
		const customer = get(userAccount, 'billingAccount.customerAccount.customer', {});
		const {code:customerCode = ""}= customer;
		const {seller={}} = customer;
		const {seller: parentSeller = {}} = seller;
		const {seller: rootSeller = {}} = parentSeller;
		const {code: rootSellerCode = ""} = rootSeller;
		PaymentService.getHostedCheckoutStatus(customerCode, rootSellerCode, pageId)
			.then(response => {
				const {status = ""} = response || {};
				if (status === "SUCCESS") {
					const { paymentStatus = ""} = response;
					EventDispatcher.success(dispatch, CONFIRM_HOSTED_CHECKOUT_STATUS, {isHostedCheckout: true, status: {hostedCheckoutConfirmed: true, paymentStatus}});
				} else {
					EventDispatcher.error(dispatch, CONFIRM_HOSTED_CHECKOUT_STATUS, {message: messages["error.payment.status.failed"]});
				}
			})
			.catch(error => {
				EventDispatcher.error(dispatch, CONFIRM_HOSTED_CHECKOUT_STATUS, error);
			});
	};
}

export function loadPaymentSession(sessionPaymentData) {
	return (dispatch, getState) => {
		EventDispatcher.loading(dispatch, LOAD_PAYMENT_SESSION);
		EventDispatcher.success(dispatch, LOAD_PAYMENT_SESSION, {payment: sessionPaymentData});
	};
}



// WEBPACK FOOTER //
// ./src/opencell/actions/PaymentActions.js